<div
  class="mat-mdc-form-field-wrapper input-text-dropdown form-group d-flex flex-column m-0"
  [class.mb-3]="control.errors && control.touched"
  (isEnglish)="isEnglish = $event"
>
  <mat-form-field class="d-block" [appearance]="appearance()" [class.readonly]="readonly()" floatLabel="always" #matFormField>
    <mat-label class="text-middle font-14">
      {{ label() | translate }}
    </mat-label>

    <div class="d-flex align-items-center w-100" [class.flex-row-reverse]="isEnglish">
      <input
        #matInput
        matInput
        class="mat-mdc-input-dropdown-element"
        dir="ltr"
        [type]="contentType()"
        [placeholder]="placeholder() | translate"
        [formControl]="control"
        [readonly]="readonly()"
        (click)="$event.stopPropagation(); control.value || dropdownValue ? null : matSelect.open()"
        (keydown)="control!.markAsTouched()"
        (keypress)="onKeyPress($event)"
        (keyup.enter)="inputValue.emit(control!.value)"
      />

      <mat-select
        [dir]="isEnglish ? 'ltr' : 'rtl'"
        #matSelect
        class="w-30"
        [compareWith]="compareWithFn"
        [formControl]="dropdownControl"
        (selectionChange)="getSelectedValue($event)"
        (openedChange)="filterControl.setValue(null)"
        (closed)="control.markAsTouched(); matInput.focus()"
        (click)="$event.stopPropagation()"
      >
        @if (withSearch()) {
          <input
            class="mat-mdc-select-search-input w-100 px-3"
            type="text"
            [formControl]="filterControl"
            [placeholder]="'ACTIONS.SEARCH' | translate"
          />
        }

        @if (dropdownSelectedValueRef()) {
          <mat-select-trigger class="d-flex align-items-center justify-content-center gap-3" [class.flex-row-reverse]="isEnglish">
            <ng-container
              [ngTemplateOutlet]="dropdownSelectedValueRef()!"
              [ngTemplateOutletContext]="{ $implicit: dropdownValue }"
            ></ng-container>
          </mat-select-trigger>
        }

        @for (option of filteredOptions; track option) {
          <mat-option [value]="option[bindValue()]" [disabled]="option.disabled">
            {{ option | localizedName }}
          </mat-option>
        }
      </mat-select>
    </div>

    @if (control.errors) {
      <mat-error class="font-12" [class]="matErrorClass()">
        {{ control.errors | validationHandler }}
      </mat-error>
    } @else if (dropdownControl.errors) {
      <mat-error class="font-12" [class]="matErrorClass()">
        {{ dropdownControl.errors | validationHandler }}
      </mat-error>
    }
  </mat-form-field>
</div>
